// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyBeSEyBeefzPdX7j7tJS1CzATF9GrFeRLo",
    authDomain: "coalab-20ab3.firebaseapp.com",
    projectId: "coalab-20ab3",
    storageBucket: "coalab-20ab3.firebasestorage.app",
    messagingSenderId: "72682073793",
    appId: "1:72682073793:web:494cc1831b08fc4f5aee40"
};

const app = initializeApp(firebaseConfig);

export const auth    = getAuth(app);
export const db      = getFirestore(app);
export const storage = getStorage(app);
export default app;
